import React, { useEffect, useState } from "react";
import axios from "axios";
import "./sipInvest.css";

function SipInvestModal({ onClose }) {
  const token = localStorage.getItem("authToken");

  const [mode, setMode] = useState(null);

  // SIP
  const [sipList, setSipList] = useState([]);
  const [symbol, setSymbol] = useState("");
  const [percentage, setPercentage] = useState("");
  const [mtfpercentage, setmtfPercentage] = useState("");
  const [editId, setEditId] = useState(null);
  const [editPercentage, setEditPercentage] = useState("");
  const [editmtfPercentage, setEditmtfPercentage] = useState("");

  // USER
  const [selectedSymbol, setSelectedSymbol] = useState("");
  const [clientId, setClientId] = useState("");
  const [amount, setAmount] = useState("");
  const [mtfamount, setmtfAmount] = useState("");
  const [ismtf, setIsmtf] = useState(false);

  const [clientDipList, setClientDipList] = useState([]);

  /* ================= LOAD SIP ================= */
  const loadSip = async () => {
    const res = await axios.get(
      " https://quatdashboard.com:8084/api/sipinvest",
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    setSipList(res.data);
  };

  useEffect(() => {
    if (mode) loadSip();
  }, [mode]);

  /* ================= SIP CRUD ================= */
  const createSip = async () => {
    try {
      await axios.post(
        " https://quatdashboard.com:8084/api/sipinvest",
        { symbol, percentage, mtfpercentage },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setSymbol("");
      setPercentage("");
      setmtfPercentage("");
      loadSip();
      alert("✅ Symbol created successfully");
    } catch (e) {
      alert("❌ Failed to create symbol");
    }
  };

  const updateSip = async (id) => {
    try {
      await axios.put(
        " https://quatdashboard.com:8084/api/sipinvest",
        { id, percentage: editPercentage, mtfpercentage: editmtfPercentage },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setEditId(null);
      loadSip();
      alert("✅ Symbol updated");
    } catch (e) {
      alert("❌ Update failed");
    }
  };

  const deleteSip = async (id) => {
    if (!window.confirm("Delete symbol?")) return;

    try {
      await axios.delete(
        ` https://quatdashboard.com:8084/api/sipinvest/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      loadSip();
      alert("✅ Symbol deleted");
    } catch (e) {
      alert("❌ Delete failed");
    }
  };

  /* ================= ADD USER ================= */
  const addUser = async () => {
    try {
      await axios.post(
        " https://quatdashboard.com:8084/api/client-dip",
        {
          clientid: clientId.trim(),
          symbol: selectedSymbol,
          amount: Number(amount),
          ismtf: ismtf,
          mtfamount: Number(mtfamount),
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setClientId("");
      setAmount("");
      setmtfAmount("");
      alert("✅ User added successfully");
    } catch (e) {
      alert("❌ Failed to add user");
    }
  };

  /* ================= EDIT USER ================= */
  const loadClientDip = async (symbol) => {
    const res = await axios.get(
      ` https://quatdashboard.com:8084/api/client-dip/symbol/${symbol}`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
    setClientDipList(res.data);
  };
  const updateUserAmount = async (row) => {
    try {
      await axios.post(
        " https://quatdashboard.com:8084/api/client-dip",
        {
          ...row,
          amount: Number(row.amount),
          ismtf: !!row.ismtf,
          mtfamount: row.ismtf ? Number(row.mtfamount) : null,
        },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      alert("✅ User updated");
    } catch (e) {
      alert("❌ Update failed");
    }
  };

  const deleteUser = async (id) => {
    try {
      await axios.delete(
        ` https://quatdashboard.com:8084/api/client-dip/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      loadClientDip(selectedSymbol);
      alert("✅ User deleted");
    } catch (e) {
      alert("❌ Delete failed");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h2>SIP Invest</h2>

        {/* ===== BUTTON BAR ===== */}
        <div className="top-buttons">
          <button onClick={() => setMode("create")}>Create Symbol</button>
          <button onClick={() => setMode("edit")}>Edit/Delete Symbol</button>
          <button onClick={() => setMode("addUser")}>Add User</button>
          <button onClick={() => setMode("editUser")}>Edit User</button>
        </div>

        {/* ===== CREATE SYMBOL ===== */}
        {mode === "create" && (
          <div className="form">
            <input
              placeholder="Symbol"
              value={symbol}
              onChange={(e) => setSymbol(e.target.value)}
            />
            <input
              placeholder="%"
              type="number"
              value={percentage}
              onChange={(e) => setPercentage(e.target.value)}
            />
            <input
              placeholder="MTF%"
              type="number"
              value={mtfpercentage}
              onChange={(e) => setmtfPercentage(e.target.value)}
            />
            <button className="save-btn" onClick={createSip}>
              Save
            </button>
          </div>
        )}

        {/* ===== EDIT / DELETE SYMBOL ===== */}
        {mode === "edit" && (
          <table className="sip-table">
            <thead>
              <tr>
                <th>Symbol</th>
                <th>%</th>
                <th>MTF%</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {sipList.map((s) => (
                <tr key={s.id}>
                  <td>{s.symbol}</td>
                  <td>
                    {editId === s.id ? (
                      <input
                        value={editPercentage}
                        onChange={(e) => setEditPercentage(e.target.value)}
                      />
                    ) : (
                      s.percentage
                    )}
                  </td>
                  <td>
                    {editId === s.id ? (
                      <input
                        value={editmtfPercentage}
                        onChange={(e) => setEditmtfPercentage(e.target.value)}
                      />
                    ) : (
                      s.mtfpercentage
                    )}
                  </td>
                  <td>
                    {editId === s.id ? (
                      <button
                        className="save-btn"
                        onClick={() => updateSip(s.id)}
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        className="edit-btn"
                        onClick={() => {
                          setEditId(s.id);
                          setEditPercentage(s.percentage);
                          setEditmtfPercentage(s.mtfpercentage);
                        }}
                      >
                        Edit
                      </button>
                    )}
                    <button
                      className="delete-btn"
                      onClick={() => deleteSip(s.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* ===== ADD USER ===== */}
        {mode === "addUser" && (
          <>
            <div className="symbol-list">
              {sipList.map((s) => (
                <button
                  key={s.id}
                  className="symbol-btn"
                  onClick={() => setSelectedSymbol(s.symbol)}
                >
                  {s.symbol}
                </button>
              ))}
            </div>

            {selectedSymbol && (
              <div className="form">
                <input
                  placeholder="Client ID"
                  value={clientId}
                  onChange={(e) => setClientId(e.target.value)}
                />
                <input
                  placeholder="Amount"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <label className="mtf-toggle">
                  <input
                    type="checkbox"
                    checked={ismtf}
                    onChange={(e) => setIsmtf(e.target.checked)}
                  />
                  Enable MTF
                </label>
                <input
                  placeholder="MTFAmount"
                  type="number"
                  value={mtfamount}
                  onChange={(e) => setmtfAmount(e.target.value)}
                />
                <button className="save-btn" onClick={addUser}>
                  Add
                </button>
              </div>
            )}
          </>
        )}

        {/* ===== EDIT USER ===== */}
        {mode === "editUser" && (
          <>
            <div className="symbol-list">
              {sipList.map((s) => (
                <button
                  key={s.id}
                  className="symbol-btn"
                  onClick={() => {
                    setSelectedSymbol(s.symbol);
                    loadClientDip(s.symbol);
                  }}
                >
                  {s.symbol}
                </button>
              ))}
            </div>

            {clientDipList.length > 0 && (
              <table className="sip-table">
                <thead>
                  <tr>
                    <th>Client</th>
                    <th>Amount</th>
                    <th>MTF</th>
                    <th>MTF Amount</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {clientDipList.map((r) => (
                    <tr key={r.id}>
                      <td>{r.clientid}</td>

                      {/* CNC Amount */}
                      <td>
                        <input
                          type="number"
                          value={r.amount}
                          onChange={(e) =>
                            setClientDipList((prev) =>
                              prev.map((x) =>
                                x.id === r.id
                                  ? { ...x, amount: e.target.value }
                                  : x,
                              ),
                            )
                          }
                        />
                      </td>

                      {/* ✅ MTF ENABLE CHECKBOX */}
                      <td>
                        <input
                          type="checkbox"
                          checked={!!r.ismtf}
                          onChange={(e) =>
                            setClientDipList((prev) =>
                              prev.map((x) =>
                                x.id === r.id
                                  ? {
                                      ...x,
                                      ismtf: e.target.checked,
                                      mtfamount: e.target.checked
                                        ? x.mtfamount
                                        : null,
                                    }
                                  : x,
                              ),
                            )
                          }
                        />
                      </td>

                      {/* ✅ MTF AMOUNT */}
                      <td>
                        <input
                          type="number"
                          disabled={!r.ismtf}
                          value={r.mtfamount ?? ""}
                          onChange={(e) =>
                            setClientDipList((prev) =>
                              prev.map((x) =>
                                x.id === r.id
                                  ? { ...x, mtfamount: e.target.value }
                                  : x,
                              ),
                            )
                          }
                        />
                      </td>

                      {/* ACTIONS */}
                      <td>
                        <button
                          className="save-btn"
                          onClick={() => updateUserAmount(r)}
                        >
                          Save
                        </button>
                        <button
                          className="delete-btn"
                          onClick={() => deleteUser(r.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}

        <button className="close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export default SipInvestModal;
